export const extractMessages = (items: any[], path = ''): string[] => {
  return items.flatMap(item => {
    const propertyPath = path ? `${path}.${item.property}` : item.property
    const constraints = Object.values(item.constraints || {}).map(msg => `${propertyPath}: ${msg}`)
    const childrenMessages = item.children?.length
      ? extractMessages(item.children, propertyPath)
      : []
    return [...constraints, ...childrenMessages]
  })
}
